import { Fragment } from "react";
import {
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
  createColumnHelper,
} from "@tanstack/react-table";

import { IShippingPolicy } from "../../models/ShippingPolicy";

const colHelper = createColumnHelper<IShippingPolicy>();

export default function AdminSettingsTable({ policies, onEditClick, }: { policies: IShippingPolicy[]; onEditClick: (policy: IShippingPolicy) => void; }) {
  const cols = [
    colHelper.accessor("name", {
      header: "Name",
    }),
    colHelper.accessor("courier", {
      header: "Courier",
      cell: (info) => info.getValue() || '-'
    }),
    colHelper.accessor("daysToDeliver", {
      header: "Days to Deliver",
    }),
    colHelper.accessor("handlingTime", {
      header: "Handling Time (Hours)",
    }),
    colHelper.accessor("price", {
      header: "Price",
      cell: (info) => <>£{info.getValue()}</>
    }),
  ];

  const table = useReactTable({
    data: policies,
    columns: cols,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <>
      <div className="mt-4 bg-white overflow-auto">
        <table className="min-w-full overflow-scroll divide-y border divide-gray-300">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id} className="bg-primary-50 text-gray-800">
                {headerGroup.headers.map((header, i) => (
                  <th
                    key={header.id}
                    scope="col"
                    className="py-3.5 px-3 text-sm font-semibold lg:table-cell text-left"
                  // style={{ width: header.getSize() }}
                  >
                    {header.isPlaceholder ? null : (
                      <div
                        {...{
                          className: header.column.getCanSort()
                            ? "cursor-pointer select-none"
                            : "",
                          onClick: header.column.getToggleSortingHandler(),
                        }}
                      >
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {{
                          asc: " ▲",
                          desc: " ▼",
                        }[header.column.getIsSorted() as string] ?? null}
                      </div>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row, i) => {
              let rowCells = row.getVisibleCells();
              return (
                <Fragment key={i}>
                  <tr
                    key={row.id}
                    className="hover:bg-gray-100 hover:cursor-pointer"
                    onClick={() => onEditClick(row.original)}
                  >
                    {rowCells.map((cell) => (
                      <td
                        key={cell.id}
                        className="px-3 py-3 border text-sm"
                        // style={{ width: cell.column.getSize() }}
                        width={`${cell.column.getSize()}%`}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
